import { __decorate } from "tslib";
import { Component, ViewChild } from '@angular/core';
import { ComponentService } from '../../../../services/component.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { Router } from '@angular/router';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { SharedHttp } from '../../../../services/http-client.service';
import { LanguageService } from '../../../../services/language.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoginComponent } from '../../../login';
import { SuccessfulRegistrationComponent } from '../../successful-registration/successful-registration.component';
import { load } from 'recaptcha-v3';
import { AuthService } from "../../../../services/auth.service";
import { GoogleAnalyticsService } from "../../../../services/google-analytics.service";
let CompanyLocationInformationComponent = class CompanyLocationInformationComponent {
    constructor(compService, sanitizer, themeService, router, webSettingsService, httpClient, languageService, formBuilder, auth, googleAnalyticsService) {
        this.compService = compService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.httpClient = httpClient;
        this.languageService = languageService;
        this.formBuilder = formBuilder;
        this.auth = auth;
        this.googleAnalyticsService = googleAnalyticsService;
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.errorColor = '';
        this.textColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.lang = '';
        this.loadingSpinner = false;
        this.keyword = 'name';
        this.countries = [];
        this.companyCountryError = false;
        this.dropdownCountriesInFocus = false;
        this.cities = [];
        this.companyCityError = false;
        this.companyAddressError = false;
        this.dropdownCitiesInFocus = false;
        this.companyLocationInfo = {
            companyCountry: undefined,
            companyAddress: undefined,
            companyCity: undefined
        };
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.citiesForm = this.formBuilder.group({
            citiesAutoComplete: ''
        });
    }
    ngOnInit() {
        this.getCountries();
    }
    ngAfterViewInit() {
        const countriesAutoCompleteListElement = this.countriesAutoComplete.elementRef.nativeElement.querySelector('ul');
        countriesAutoCompleteListElement.className = 'countriesList';
        const countriesAutoCompleteInputElement = this.countriesAutoComplete.elementRef.nativeElement.querySelector('input');
        countriesAutoCompleteInputElement.id = 'companyCountry';
        const citiesAutoCompleteListElement = this.citiesAutoComplete.elementRef.nativeElement.querySelector('ul');
        citiesAutoCompleteListElement.className = 'citiesList';
        const citiesAutoCompleteInputElement = this.citiesAutoComplete.elementRef.nativeElement.querySelector('input');
        citiesAutoCompleteInputElement.id = 'companyCity';
    }
    getCountries() {
        this.httpClient.get('user/registrationcountries').subscribe((data) => {
            this.countries = data;
        });
    }
    getCitiesForCountryId(countryId) {
        if (countryId !== '') {
            this.httpClient.get('user/registrationcities/' + countryId).subscribe((data) => {
                this.cities = data;
                this.cities.forEach(city => {
                    city.formattedName = city.name + ' ' + city.postal_code;
                });
            });
        }
    }
    setCountry(item) {
        this.companyLocationInfo.companyCountry = item.id;
        this.getCitiesForCountryId(item.id);
    }
    setCity(item) {
        this.companyLocationInfo.companyCity = item.id;
        this.checkCompanyCity();
    }
    checkCompanyCountry() {
        this.companyCountryError = this.companyLocationInfo.companyCountry === 'null' || this.companyLocationInfo.companyCountry === undefined;
        return !this.companyCityError;
    }
    checkCompanyCity() {
        this.companyCityError = this.companyLocationInfo.companyCity === 'null' || this.companyLocationInfo.companyCity === undefined;
        return !this.companyCityError;
    }
    checkCompanyAddress() {
        this.companyAddressError = this.companyLocationInfo.companyAddress === undefined || this.companyLocationInfo.companyAddress.length < 3 || (this.companyLocationInfo.companyAddress.split(' ').length < 2);
        return !this.companyAddressError;
    }
    onFocusedCountry(e) {
        this.dropdownCountriesInFocus = e;
        this.companyCountryError = !e && !this.companyLocationInfo.companyCountry;
    }
    onFocusedCity(e) {
        this.dropdownCitiesInFocus = e;
        this.companyCityError = !e && !this.companyLocationInfo.companyCity;
    }
    onCountriesClear(e) {
        this.companyLocationInfo.companyCountry = null;
        this.companyLocationInfo.companyCity = null;
        this.cities = [];
        this.citiesForm.get('citiesAutoComplete').patchValue(null);
    }
    onCitiesClear(e) {
        this.companyLocationInfo.companyCity = null;
    }
    checkIfFormIsValid() {
        return Object.values(this.companyLocationInfo).some(field => field === undefined || field === null || field === '')
            || this.companyCountryError || this.companyCityError || this.companyAddressError;
    }
    register() {
        if (this.checkCompanyCountry() && this.checkCompanyCity() && this.checkCompanyAddress()) {
            const registerData = Object.assign(Object.assign(Object.assign({}, this.data.registerData), this.data.baseCompanyData), this.companyLocationInfo);
            this.loadingSpinner = true;
            this.httpClient.post('user/registration', registerData).subscribe((result) => {
                if (result['auth_token']) {
                    this.auth.setLoggedIn(true);
                    this.auth.setToken(result['auth_token'], result['token_duration']);
                    localStorage.setItem('refresh_token', result['refresh_token']);
                    if (localStorage.getItem('auth_token')) {
                        this.auth.fetchUser().then(() => {
                            const user = JSON.parse(localStorage.getItem('user'));
                            localStorage.setItem('defaultCurrency', this.webSettingsService.getWebSetting('DEFAULT_CURRENCY'));
                            localStorage.setItem('allowedDecimalPlaces', this.webSettingsService.getWebSetting('WALLET.NUMBER_OF_DECIMALS_BUY_SELL'));
                            if (user.wallet_blocked) {
                                localStorage.setItem('ResetMfaMessageModalComponentShownOnStart', '0');
                            }
                            const array = [];
                            array.push({
                                event: 'loggedIn',
                                userId: user.id
                            });
                            this.googleAnalyticsService.pushGAEvents(array);
                            this.verifyPageShownOnLogin = user.settings.verify_page_shown_on_login;
                            if (this.verifyPageShownOnLogin) {
                                this.router.navigateByUrl('/verify');
                            }
                            else if (this.webSettingsService.getWebSetting('DEFAULT_ROUTE') !== '') {
                                this.router.navigateByUrl(this.webSettingsService.getWebSetting('DEFAULT_ROUTE'));
                            }
                            this.loadingSpinner = false;
                            this.modal.destroy();
                        });
                    }
                }
                else {
                    this.loadingSpinner = false;
                    this.modal.destroy();
                    this.compService.openModal(SuccessfulRegistrationComponent);
                }
                this.setRecaptchaToken();
            }, (error) => {
                this.setRecaptchaToken();
                this.loadingSpinner = false;
            });
        }
    }
    setRecaptchaToken() {
        load(localStorage.getItem('recaptcha_site_key')).then((recaptcha) => {
            recaptcha.execute('submit').then((token) => {
                this.data.registerData.recaptchaToken = token;
            });
        });
    }
    alreadyHave() {
        this.modal.destroy();
        this.compService.openModal(LoginComponent);
    }
    close() {
        document.body.className = '';
        this.router.navigateByUrl('/');
        this.modal.destroy();
    }
    goBack() {
        this.error({ registerData: this.data.registerData, baseCompanyData: this.data.baseCompanyData });
        document.body.className = '';
        this.modal.destroy();
    }
};
CompanyLocationInformationComponent.ctorParameters = () => [
    { type: ComponentService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: WebClientService },
    { type: SharedHttp },
    { type: LanguageService },
    { type: FormBuilder },
    { type: AuthService },
    { type: GoogleAnalyticsService }
];
__decorate([
    ViewChild('countriesAutoComplete')
], CompanyLocationInformationComponent.prototype, "countriesAutoComplete", void 0);
__decorate([
    ViewChild('citiesAutoComplete')
], CompanyLocationInformationComponent.prototype, "citiesAutoComplete", void 0);
CompanyLocationInformationComponent = __decorate([
    Component({
        selector: 'app-company-location-information',
        template: __importDefault(require("./company-location-information.component.html")).default,
    })
], CompanyLocationInformationComponent);
export { CompanyLocationInformationComponent };
